import React from 'react'
import styled from 'styled-components'
import { LogoIcon } from './LogoIcon'
import { LogoText } from './LogoText'

interface Props {
  className?: string
}

export function Logo({ className }: Props) {
  return (
    <Content className={className}>
      <LogoIconStyled />
      <LogoTextStyled />
    </Content>
  )
}

const Content = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
`

const LogoIconStyled = styled(LogoIcon)`
  flex-basis: 15.61%;
  height: 100%;
`

const LogoTextStyled = styled(LogoText)`
  flex-basis: 76.19%;
  height: 30%;
`
